import React from 'react';
import { useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';

import { FormCheckbox } from '@uncinc/uncinc-react-kitchen-sink';

import { formatBibciteMetadata } from '../../../../helpers/content';
import Card from '../../../Card';
import type { SearchAllContentPracticalMaterialHit } from '../../types';

// eslint-disable-next-line max-len
const SearchAllContentResultsPracticalMaterialHit: React.FC<{ hit: SearchAllContentPracticalMaterialHit }> = ({ hit }) => {
  const { t } = useTranslation();

  return (
    <div className="SearchAllContent__Results__hit-wrapper">
      <FormCheckbox
        wrapperClassName="SearchAllContent__Results__checkbox"
        fieldName={`${hit.nid[0]}`}
      />

      <Card
        className="SearchAllContent__Results__hit"
        url={hit.url[0]}
        label={t(`content_types.${hit.type[0]}.type`)}
        labelIcon="topic"
        title={<Highlight attribute="title" hit={hit} />}
        link={hit.bibcite_url?.[0]}
        linkText={t(`components.search_all_content.results.hit_link_text.${hit.type[0]}`)}
        subtitle={formatBibciteMetadata(
          hit.name,
          hit.bibcite_secondary_title?.[0],
          hit.bibcite_publisher?.[0],
          hit.bibcite_year?.[0],
          hit.bibcite_volume?.[0],
          hit.bibcite_issue?.[0],
          hit.bibcite_pages?.[0],
        )}
      />
    </div>
  );
};

export default SearchAllContentResultsPracticalMaterialHit;
